import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Construction } from "lucide-react";

interface BackendPendingPageProps {
  /** The name of the screen that is not connected yet (e.g. "Billing"). */
  title: string;
  /** Optional override for the default explanatory copy. */
  description?: string;
}

const DEFAULT_DESCRIPTION =
  "This screen is not connected to the API yet. Its backend is planned and " +
  "still on the way — the page will return automatically once its endpoints ship.";

/**
 * Route-level "backend not connected yet" panel. Rendered by `BackendPendingGate`
 * in place of a page whose supporting CMS API does not exist yet, so the route is
 * honest instead of firing requests at URLs that 404 or showing fabricated data.
 *
 * Shape mirrors the access-denied precedent (`auth/RequireMenuAccess.tsx`) — a
 * `flex-1 p-6` wrapper around an `<Alert>` — but uses `variant="default"`, NOT
 * `destructive`: this is a planned gap, not an error, and must not read as one.
 */
export default function BackendPendingPage({
  title,
  description = DEFAULT_DESCRIPTION,
}: BackendPendingPageProps) {
  return (
    <div className="flex-1 p-6" data-testid="route-backend-pending">
      <Alert variant="default">
        <Construction className="h-4 w-4" />
        <AlertTitle>{title} — backend not connected yet</AlertTitle>
        <AlertDescription>{description}</AlertDescription>
      </Alert>
    </div>
  );
}
